import React from 'react'
import { useState,useEffect } from 'react'
import './sidebar.css'
import { Avatar, IconButton } from '@material-ui/core'
import ChatIcon from  '@material-ui/icons/Chat'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import Fade from '@material-ui/core/Fade'
import { DonutLarge, MoreVert, SearchOutlined } from '@material-ui/icons'
import SidebarChat from './SidebarChat'
import Box from '@material-ui/core/Box'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import db from './firebase'
import {auth} from './firebase'
import { useStateValue } from './StateProvider';


function Sidebar() {
  const[rooms,setRooms] = useState([]);
  const[{user},dispatch] = useStateValue();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [Messageopen, setOpen] = React.useState(false);

  const handleClick2 = () => {
    setOpen((prev) => !prev);
  };
  const handleClickAway = () => {
    setOpen(false);
  };

  useEffect(()=>{
    const unsubscribe =  db.collection("rooms").onSnapshot((snapshot) =>
       setRooms(snapshot.docs.map((doc) => ({
         id: doc.id,
         data: doc.data(),
        
       })))
     )

     return ()=>{
      unsubscribe();
     }
  },[])


  return (
    <div className='chat_sidebar'>
       <div className='sidebar_header'>
           <Avatar src={user?.photoURL} />
           <div className='header_icons'>
            <IconButton>
             <DonutLarge className='sidebar_icon' />
             </IconButton>
            
             <ClickAwayListener onClickAway={handleClickAway}>
            <Box sx={{ position: 'relative' }}>
            <ChatIcon onClick={handleClick2} className='sidebar_icon' />
            {Messageopen ? (
            <Box className='styles'>
             below add a new chat or search...
             </Box>
            ) : null}
           </Box>
            </ClickAwayListener>
  
      <div>
      <Button
        id="fade-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
     <MoreVert />
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleClose}>LogOut</MenuItem>
        <MenuItem onClick={handleClose}>Linked Devices</MenuItem>
        <MenuItem onClick={handleClose}>New BroadCast</MenuItem>
        <MenuItem onClick={handleClose}>Payments</MenuItem>
      </Menu>
    </div>
     
   
              
      </div>
      </div>
      

  
    
 
       <div className='sidebar_searchbar'>
        <div className='searchbar_field'>
        <SearchOutlined className='search-icon'/>
        <input type="text" placeholder='search or start a new chart' />  
        </div>       
       </div>

       <div className='sidebar_chat'>
  
          <SidebarChat addNewChat/>
          {rooms.map(room=>(
            <SidebarChat key={room.id} id={room.id} name={room.data.name}/>
          ))}
       </div>
    </div>
  )
}

export default Sidebar